/* eslint-disable no-unused-vars */
import _ from "lodash";

import { mapActions, mapGetters, mapMutations } from "vuex";

import OActionButtons from "../components/forms/OActionButtons.vue";

export default function (moduleName, modelName) {
    return {
        props: {
            create: { type: Boolean, default: false },
        },
        components: {
            OActionButtons,
        },
        methods: {
            ...mapMutations(["showMessage"]),
            ...mapActions(moduleName + "Module", [
                "getById",
                "createNew",
                "saveItem",
                "deleteItem",
            ]),

            reset() {
                if (this.formState.dirty) {
                    this.clean = false;
                }
            },
            enableDebug(e) {
                if (e.shiftKey) {
                    this.formState.debug = !this.formState.debug;
                }
            },
            catchError({ response }) {
                if ("status" in response && response.status === 400) {
                    this.clean = true;
                    this.serverErrors = _.clone(response.data);
                }
                let msg = "An error has occurred!";
                this.showMessage({ message: msg, type: "danger", show: true });
                return response;
            },
            _doSave(okHandler) {
                let vm = this;

                this.saveItem(this.item)
                    .then((result) => {
                        var msg = "Updated Item";
                        if (vm.create) {
                            msg = "Created Item";
                        }

                        vm.showMessage({
                            message: msg,
                            type: "success",
                            show: true,
                        });
                        vm.serverErrors = {};
                        vm.clean = true;

                        vm.formState.dirty = false; // Reset to Not dirty as we Just saved

                        if ("hookSave" in vm) {
                            // call hookSave if there is a method here
                            vm.hookSave(result, vm.create);
                        }

                        if (okHandler) okHandler(result);
                    })
                    .catch(this.catchError);
            },
            doSave() {
                let vm = this;
                this._doSave(function (result) {
                    if (vm.create) {
                        vm.$router.replace({
                            name: modelName + ".edit",
                            params: { id: result.id },
                        });
                    } else {
                        //Deep-copy to fix console errors on vuex mutations
                        vm.item = _.clone(result); // Copy out of vuex
                    }
                });
            },
            doClose() {
                this.$router.go(-1);
            },
            doSaveAndClose() {
                let vm = this;

                this._doSave(function (result) {
                    vm.doClose();
                });
            },
            doSaveAndNew() {
                let vm = this;

                this._doSave(function (result) {
                    vm.doCreateNew();
                    vm.$router.replace({ name: modelName + ".create" });
                });
            },
            doCreateNew() {
                const vm = this;
                this.createNew().then((result) => {
                    vm.item = _.clone(result); // Copy out of vuex
                    vm.clean = true;

                    /* Capture query params that start with _ and use them to set defaults so we could do
                      Something like model/create?_name=DefaultName
                      And set the "name" property as "DefaultName" when creating the new item
                     */
                    _.forEach(vm.$route.query, function (val, key) {
                        if (key.startsWith("_")) {
                            key = key.substring(1);

                            vm.$set(vm.item, key, val);
                        }
                    });

                    if (vm.OnCreateNew) {
                        // if there is a function setDefaults then use that to set the defaults for this item
                        vm.OnCreateNew(vm.item);
                    }
                });
            },
            doDeleteItem() {
                let vm = this;

                this.deleteItem(this.item).then((result) => {
                    if ("hookDelete" in vm) {
                        // call hookDelete if there is a method here
                        vm.hookDelete(result);
                    }

                    vm.doClose();
                });
            },
            unlockForm() {
                if (this.formState) {
                    this.$set(this.formState, "locked", false);
                }
            },
        },
        computed: {
            ...mapGetters(moduleName + "Module", ["working"]),
        },
        created() {
            if (!this.create) {
                this.getById(this.$route.params.id).then((result) => {
                    this.item = _.cloneDeep(result); // Copy out of vuex
                    this.clean = true;
                });
            } else {
                this.doCreateNew();
            }
        },
        mounted() {
            window.lockLeave = true; // show prevent message
        },
        data: () => ({
            item: {},

            serverErrors: {},

            clean: true, // add here so we can watch it

            formState: {
                dirty: false,
                invalid: false,
                error: false,
                init: true,
                debug: false,
                locked: false /* Default to unlocked */,
                //Remove
                valid: true,
            },
        }),
    };
}
